import { render, staticRenderFns } from "./delegation_groupItem.vue?vue&type=template&id=188bf189&scoped=true"
import script from "./delegation_groupItem.vue?vue&type=script&lang=js"
export * from "./delegation_groupItem.vue?vue&type=script&lang=js"
import style0 from "./delegation_groupItem.vue?vue&type=style&index=0&id=188bf189&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188bf189",
  null
  
)

export default component.exports